import { Component, Input } from '@angular/core';
import { DataService } from 'src/app/services';

@Component({
  selector: 'app-catalogue-history',
  templateUrl: './catalogue-history.component.html',
  styleUrl: './catalogue-history.component.css'
})
export class CatalogueHistoryComponent {

  @Input() tabType: string;
  @Input() historyData: any;

  constructor(private _dataSer: DataService) { }

  /**
   * Switchs tab
   */
  switchTab() {
    this._dataSer.broadcast('switchToHistoryTab');
  }
}
